import { icons } from './NavbarHelixIcons.js';

var NavbarHelixIcon = function NavbarHelixIcon(_ref) {
  var iconName = _ref.iconName;
  return icons[iconName] || null;
};

export { NavbarHelixIcon };